import type {
    competence,
    test,
    testType,
    thematicArea,
} from "@/features/simulationConfiguration/types.api";
import axiosInstance from "@/lib/axios";
import type { paginatedResponse } from "@/types/api/paginated.api";

export const getTestTypes = async (): Promise<testType[]> => {
    const { data } = await axiosInstance.get<testType[]>(`/test-types/`);
    return data;
};

export const getThematicAreas = async (): Promise<thematicArea[]> => {
    const { data } = await axiosInstance.get<thematicArea[]>(`/thematic-areas/`);
    return data;
};

export const getCompetences = async (): Promise<competence[]> => {
    const { data } = await axiosInstance.get<competence[]>(`/competences/`);
    return data;
};

export const getSimulationTests = async (
    simId: string,
): Promise<paginatedResponse<test>> => {
    const { data } = await axiosInstance.get<paginatedResponse<test>>(
        `/simulations/${simId}/tests/`,
    );

    return data;
};

export const getSimulationTestById = async (
    simId: string,
    sessionId: number,
    testId: number | string,
): Promise<test> => {
    const { data } = await axiosInstance.get<test>(
        `/simulations/${simId}/sessions/${sessionId}/tests/${testId}/`,
    );
    return data;
};

export const saveSimulationTest = async (
    simId: string,
    sessionId: number,
    testId: number,
    testData: test,
): Promise<test> => {
    const url = `/simulations/${simId}/sessions/${sessionId}/tests/${testId}/`;
    const { data } = await axiosInstance.put<test>(url, testData);
    return data;
};
